export default __webpack_public_path__ + "static/media/deploy.349a48b5.svg";